import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=3bf3ed71&scoped=true"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf3ed71",
  null
  
)

export default component.exports